import { Formatters, Messages } from '../../../codegen/Localize';
import {
  ActionHelpers,   standardActionErrorMsg,
standardActionSuccessMsg
} from '../../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../../commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { AccelerationTasks } from '../../../dataAcceleration/resources/AccelerationTasks';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../L10n/L10n';
import { IAccelerationTaskInfo } from '../../models/IAccelerationTaskInfo';
import { Set } from '../../models/Set';
import { DataAccelerationErrors } from './DataAccelerationErrors';

function executeWithContext(
  accelerationTasks: Set<IAccelerationTaskInfo>): Promise<IResult> {

  let dialogBody: string;
  const taskCount = accelerationTasks.size();
  if(taskCount === 1) {
    const task = accelerationTasks.first();
    dialogBody = Messages.deleteDataAccelerationTaskForWorkbookPrompt({
      WORKBOOK_NAME: L10n.elideIfLong(task.workbook.name)
    });
  } else {
    dialogBody = Messages.deleteDataAccelerationTasksPrompt({
      ITEM_COUNT_LOC: Formatters.formatCount(taskCount)
    });
  }

  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.deleteMessage(),
    message: dialogBody,
    actionName: Messages.confirmDeleteButton({ITEM_COUNT: taskCount, ITEM_COUNT_LOC: Formatters.formatCount(taskCount)}),
    paramsForAction: accelerationTasks.keys(),
    isActionDelete: true,
    action: AccelerationTasks.del.bind(AccelerationTasks),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ActionHelpers.displayStandardToastsForResult(
      accelerationTasks,
      result,
      {
        success: standardActionSuccessMsg(Messages.deleteDataAccelerationTasksSuccess),
        error: standardActionErrorMsg(Messages.deleteDataAccelerationTasksError),
      },
      (errorItem: IErrorItem<IAccelerationTaskInfo>) => DataAccelerationErrors.errorDetailsForTasks(errorItem)
    );
  });

  return dialogInstance.result;
}

export const DeleteDataAccelerationTasksAction = {
  executeWithContext
};

export type DeleteDataAccelerationTasksAction = typeof DeleteDataAccelerationTasksAction;
